// extracted by mini-css-extract-plugin
export default {"carousel":"LocationSection_carousel__fusrS","location":"LocationSection_location__oYWwN"};